/** True when the browser reports Windows (client-side only). */
export function isWindowsClient(): boolean {
  if (typeof navigator === "undefined") return false;
  const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } })
    .userAgentData;
  if (uaData?.platform && /win/i.test(uaData.platform)) return true;
  if (/win/i.test(navigator.platform || "")) return true;
  if (/windows/i.test(navigator.userAgent || "")) return true;
  return false;
}

/**
 * Sets `data-os-windows` on `<html>` so styles can show native scrollbars on
 * case listings without affecting macOS/Linux (global CSS hides scrollbars).
 */
export function initCaseListingWindowsOsFlag(): void {
  if (typeof document === "undefined") return;
  if (!isWindowsClient()) return;
  document.documentElement.setAttribute("data-os-windows", "true");
}
